import type { PerAssessmentResponse } from '@lmc/ts-common'
import { getJSON } from 'common/services/api'
import dayjs from 'dayjs'
import qs from 'qs'
import { useState } from 'react'
import { useQuery } from 'react-query'
import DashboardBody from './components/DashboardBody/DashboardBody'
import DashboardFilters, {
  type PerAssessmentFilters
} from './components/DashboardFilters/DashboardFilters'

export const initialFiltersValue: PerAssessmentFilters = {
  rangePicker: [dayjs().subtract(12, 'month'), dayjs()],
  residents: [],
  riskAssessment: null
}

export const generateApiUrl = (filterParams: PerAssessmentFilters) => {
  const { riskAssessment, residents, rangePicker } = filterParams

  const queryStr = qs.stringify({
    formId: riskAssessment,
    residents,
    from: rangePicker?.[0]?.startOf('day').toISOString(),
    to: rangePicker?.[1]?.endOf('day').toISOString()
  })

  return `/api/list/risk-assessments/dashboard/per-assessment?${queryStr}`
}

const PerAssessmentScreen = (): JSX.Element => {
  const [filterParams, setFilterParams] =
    useState<PerAssessmentFilters>(initialFiltersValue)
  const url = generateApiUrl(filterParams)

  const { isLoading, data } = useQuery<PerAssessmentResponse>(url, () =>
    getJSON({ url })
  )

  return (
    <>
      <DashboardFilters onChange={setFilterParams} value={filterParams} />
      <DashboardBody
        data={data}
        filterParams={filterParams}
        isLoading={isLoading}
      />
    </>
  )
}

export default PerAssessmentScreen
